export default {
  validate: function (value) {
    return /^.{8,12}$/.test(value)
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/passwordLength.js